import React from 'react';

import { Space } from 'antd-v5';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import { CouncilDistrictBadge, ProgramLogo } from '@shared/components';
import type { UserOrganizationInfo } from '@user/types';

import styles from './RolePickerRole.less';
import RolePickerBaseRole from './components/RolePickerBaseRole';

interface RolePickerCouncilRole {
  active: boolean;
  disabled: boolean;
  org: UserOrganizationInfo;
  unitRole: UserOrganizationInfo;
  onProfileChange: (organizationGuid: string) => void;
}
function RolePickerCouncilRole(props: RolePickerCouncilRole) {
  const { active, unitRole, disabled, org, onProfileChange } = props;
  const positionNames = org.role;
  const extraPositions = _.chain(org)
    .get('allRoles')
    .uniq()
    .filter(position => position !== positionNames)
    .value();
  const { unitTypeId } = unitRole || {};
  const extraPositionsLabel = extraPositions.join('\n');
  const hasExtraPositions = extraPositions.length > 0;
  return (
    <RolePickerBaseRole
      org={org}
      active={active}
      disabled={disabled}
      onProfileChange={onProfileChange}
    >
      <div className={styles.councilRoleLogoWrapper}>
        <ProgramLogo programId={unitTypeId} className={styles.logo} />
        <CouncilDistrictBadge
          organizationTypeId={org.organizationTypeId}
          councilStructureTypeId={org.councilStructureTypeId}
        />
      </div>
      <div className={styles.description}>
        <Space direction="vertical" size={2}>
          <Space direction="vertical" size={0}>
            <Text font="body-body-4">{org.organizationName}</Text>
          </Space>
          <Text font="body-caption">
            <FormattedMessage id="context.RolePicker.position" />:{' '}
            {positionNames}
          </Text>
          {hasExtraPositions && (
            <Text
              className={styles.extraPositionsLabel}
              font="body-caption"
              title={extraPositionsLabel}
            >
              <FormattedMessage
                id="context.RolePicker.extraPositions"
                values={{ count: extraPositions.length }}
              />
            </Text>
          )}
        </Space>
      </div>
    </RolePickerBaseRole>
  );
}

export default RolePickerCouncilRole;
